export default __webpack_public_path__ + "796e5ba286b4e5cc126718fc01c3e250.png";